// class IrisLearnsCartBundleManager {
//   constructor() {
//     console.log('=== Iris Learns Cart Bundle Manager Initialized ===');

//     this.productIds = {
//       device: 10210718941368,      // Iris Learner
//       software: 10217114271928     // Exo Works Learner
//     };

//     this.cart = null;
//     this.bundles = [];
//     this.isReInitializing = false;
//     this.reInitTimeout = null;
//     this.init();
//   }

//   async init() {
//     if (document.readyState === 'loading') {
//       document.addEventListener('DOMContentLoaded', () => this.setup());
//     } else {
//       this.setup();
//     }
//   }

//   async setup() {
//     if (!window.location.pathname.includes('/cart')) return;

//     await this.loadCart();
//     await this.normalizeQuantities();
//     this.analyzeBundles();
//     this.renderBundles();
//     this.setupCartUpdateListeners();

//     console.log('=== Iris Learns Cart Setup Complete ===');
//   }

//   setupCartUpdateListeners() {
//     console.log('[IrisLearns] 🎯 Setting up cart update listeners...');

//     const originalFetch = window.fetch;
//     const self = this;

//     window.fetch = function(...args) {
//       const url = args[0];

//       if (typeof url === 'string' && (url.includes('/cart/change') || url.includes('/cart/update'))) {
//         console.log('[IrisLearns] 🌐 Cart update detected');

//         return originalFetch.apply(this, args).then(response => {
//           if (self.reInitTimeout) {
//             clearTimeout(self.reInitTimeout);
//           }

//           self.reInitTimeout = setTimeout(() => {
//             console.log('[IrisLearns] ⏰ Re-initializing after cart update');
//             self.reInitialize();
//           }, 1000);

//           return response;
//         });
//       }

//       return originalFetch.apply(this, args);
//     };

//     console.log('[IrisLearns] ✅ Fetch interceptor installed');
//   }

//   async reInitialize() {
//     if (this.isReInitializing) {
//       console.log('[IrisLearns] ⚠️ Re-initialization already in progress, skipping...');
//       return;
//     }

//     this.isReInitializing = true;
//     console.log('[IrisLearns] 🔄 === Re-initializing ===');

//     // Clear existing Iris Learns bundle cards
//     document.querySelectorAll('[id^="IrisLearnsBundle-"]').forEach(el => el.remove());

//     // Show any hidden items
//     this.cart.items.forEach((item, index) => {
//       const cartItemIndex = index + 1;
//       const selectors = [
//         `#CartItem-${cartItemIndex}`,
//         `[data-index="${cartItemIndex}"]`
//       ];

//       for (const selector of selectors) {
//         const element = document.querySelector(selector);
//         if (element) {
//           const row = element.closest('tr, li, .cart-item');
//           if (row) {
//             row.style.display = '';
//           }
//         }
//       }
//     });

//     // Re-run bundle logic
//     await this.loadCart();
//     await this.normalizeQuantities();
//     this.analyzeBundles();
//     this.renderBundles();

//     console.log('[IrisLearns] ✅ === Re-initialization Complete ===');
//     this.isReInitializing = false;
//   }

//   async loadCart() {
//     const response = await fetch('/cart.js');
//     this.cart = await response.json();
//     console.log('[IrisLearns] Cart loaded:', this.cart.items.length, 'items');
//   }

// async normalizeQuantities() {
//     const devices = this.cart.items.filter(i => i.product_id === this.productIds.device);
//     const softwares = this.cart.items.filter(i => i.product_id === this.productIds.software);

//     if (devices.length === 0 || softwares.length === 0) return;

//     const updates = {};
//     let needsUpdate = false;
//     const usedKeys = new Set();

//     devices.forEach(device => {
//       const deviceProgram = device.properties?.['Program Name'] || '';
      
//       let matchedSoftware = softwares.find(s => 
//         !usedKeys.has(s.key) && 
//         (s.properties?.['Program Name'] || '') === deviceProgram
//       );

//       if (!matchedSoftware) {
//         matchedSoftware = softwares.find(s => !usedKeys.has(s.key));
//       }

//       if (matchedSoftware) {
//         usedKeys.add(matchedSoftware.key);
//         if (device.quantity !== matchedSoftware.quantity) {
//           const maxQty = Math.max(device.quantity, matchedSoftware.quantity);
//           updates[device.key] = maxQty;
//           updates[matchedSoftware.key] = maxQty;
//           needsUpdate = true;
//         }
//       }
//     });

//     if (needsUpdate) {
//       console.log('[IrisLearns] Syncing quantities:', updates);
//       await fetch('/cart/update.js', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({ updates })
//       });
//       await this.loadCart();
//     }
//   }

// analyzeBundles() {
//     this.bundles = [];
//     const usedKeys = new Set();

//     const devices = this.cart.items.filter(i => i.product_id === this.productIds.device);
//     const softwares = this.cart.items.filter(i => i.product_id === this.productIds.software);

//     devices.forEach(device => {
//       // Try to find a matching software with the same Program Name property
//       const deviceProgram = device.properties?.['Program Name'] || '';
      
//       let matchedSoftware = softwares.find(s => 
//         !usedKeys.has(s.key) && 
//         (s.properties?.['Program Name'] || '') === deviceProgram
//       );

//       // Fallback: match any unused software
//       if (!matchedSoftware) {
//         matchedSoftware = softwares.find(s => !usedKeys.has(s.key));
//       }

//       if (matchedSoftware) {
//         usedKeys.add(device.key);
//         usedKeys.add(matchedSoftware.key);
//         this.bundles.push({ device, software: matchedSoftware });
//         console.log('[IrisLearns] Bundle found:', device.quantity, 'x Iris Learns, Program:', deviceProgram || '(none)');
//       }
//     });

//     console.log(`[IrisLearns] Total bundles: ${this.bundles.length}`);
//   }

//   renderBundles() {
//     if (this.bundles.length === 0) return;

//     const cartForm = document.querySelector('form[action="/cart"]');
//     if (!cartForm) return;

//     const itemsContainer = cartForm.querySelector('.cart-items tbody') ||
//                            cartForm.querySelector('.cart-items');
//     if (!itemsContainer) return;

//     this.bundles.forEach((bundle, index) => {
//       this.hideCartItem(bundle.device.key);
//       this.hideCartItem(bundle.software.key);

//       const bundleCard = this.createBundleCard(bundle, index);
//       itemsContainer.insertBefore(bundleCard, itemsContainer.firstChild);
//     });
//   }

//   hideCartItem(key) {
//     const index = this.cart.items.findIndex(item => item.key === key) + 1;
//     const selectors = [
//       `#CartItem-${index}`,
//       `[data-index="${index}"]`,
//       `[data-key="${key}"]`
//     ];

//     for (const selector of selectors) {
//       const element = document.querySelector(selector);
//       if (element) {
//         const row = element.closest('tr, li, .cart-item');
//         if (row) {
//           row.style.display = 'none';
//           return;
//         }
//       }
//     }
//   }

//   createBundleCard(bundle, index) {
//     const totalPrice = (
//       bundle.device.final_line_price + bundle.software.final_line_price
//     ) / 100;

//     const row = document.createElement('tr');
//     row.className = 'cart-item';
//     row.id = `IrisLearnsBundle-${index + 1}`;

//     row.innerHTML = `
//       <td class="cart-item__media">
//         <a href="${bundle.device.url}" class="cart-item__link" aria-hidden="true" tabindex="-1"></a>
//         <div class="cart-item__image-container gradient global-media-settings">
//           <img
//             src="${bundle.device.image}"
//             class="cart-item__image"
//             alt="${bundle.device.product_title}"
//             loading="lazy"
//             width="150"
//             height="150"
//           >
//         </div>
//       </td>

//       <td class="cart-item__details">
//         <a href="${bundle.device.url}" class="cart-item__name h4 break">
//           Iris Learns
//         </a>
//         <div class="product-option">
//           <p>Includes Exo Iris and Exo Works Essential Software.</p>
//         </div>
//       </td>

//       <td class="cart-item__totals right medium-hide large-up-hide">
//         <div class="cart-item__price-wrapper">
//           <span class="price price--end">$${totalPrice.toFixed(2)}</span>
//         </div>
//       </td>

//       <td class="cart-item__quantity">
//         <div class="cart-item__quantity-wrapper">
//           <quantity-input class="quantity cart-quantity">
//             <button class="quantity__button" name="minus" type="button" data-action="decrease" data-learns-bundle="${index}">
//               <span class="visually-hidden">Decrease quantity</span>
//               <span class="svg-wrapper">
//                 <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-minus" fill="none" viewBox="0 0 10 2">
//                   <path fill-rule="evenodd" clip-rule="evenodd" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 110 1H1A.5.5 0 01.5 1z" fill="currentColor"/>
//                 </svg>
//               </span>
//             </button>
//             <input
//               class="quantity__input"
//               type="number"
//               value="${bundle.device.quantity}"
//               min="1"
//               readonly
//             >
//             <button class="quantity__button" name="plus" type="button" data-action="increase" data-learns-bundle="${index}">
//               <span class="visually-hidden">Increase quantity</span>
//               <span class="svg-wrapper">
//                 <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-plus" fill="none" viewBox="0 0 10 10">
//                   <path fill-rule="evenodd" clip-rule="evenodd" d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z" fill="currentColor"/>
//                 </svg>
//               </span>
//             </button>
//           </quantity-input>
//           <cart-remove-button>
//             <button class="button button--tertiary" type="button" data-learns-bundle="${index}">
//               <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" aria-hidden="true" focusable="false" class="icon icon-remove">
//                 <path d="M14 3h-3.53a3.07 3.07 0 00-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 005.53 3H2a.5.5 0 000 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 00.5-.5V4H14a.5.5 0 000-1zM6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02zm4.84 11.52h-7.5V4h7.5v9.5z" fill="currentColor"></path>
//                 <path d="M6.55 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5zM9.45 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5z" fill="currentColor"></path>
//               </svg>
//             </button>
//           </cart-remove-button>
//         </div>
//       </td>

//       <td class="cart-item__totals right small-hide">
//         <div class="cart-item__price-wrapper">
//           <span class="price price--end">$${totalPrice.toFixed(2)}</span>
//         </div>
//       </td>
//     `;

//     // Quantity buttons
//     row.querySelectorAll('button[data-action]').forEach(btn => {
//       btn.addEventListener('click', (e) => {
//         e.preventDefault();
//         e.stopPropagation();
//         this.handleQuantityChange(e, bundle);
//       });
//     });

//     // Remove button
//     row.querySelector('cart-remove-button button').addEventListener('click', (e) => {
//       e.preventDefault();
//       e.stopPropagation();
//       this.handleRemove(bundle);
//     });

//     return row;
//   }

//   async handleQuantityChange(e, bundle) {
//     const action = e.currentTarget.dataset.action;
//     const currentQty = bundle.device.quantity;
//     const newQty = action === 'increase' ? currentQty + 1 : Math.max(0, currentQty - 1);

//     if (newQty === 0) {
//       return this.handleRemove(bundle);
//     }

//     await this.updateCart({
//       [bundle.device.key]: newQty,
//       [bundle.software.key]: newQty
//     });
//   }

//   async handleRemove(bundle) {
//     await this.updateCart({
//       [bundle.device.key]: 0,
//       [bundle.software.key]: 0
//     });
//   }

//   async updateCart(updates) {
//     try {
//       const response = await fetch('/cart/update.js', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({ updates })
//       });

//       if (response.ok) {
//         window.location.reload();
//       }
//     } catch (error) {
//       console.error('[IrisLearns] Update failed:', error);
//     }
//   }
// }

// console.log('Iris Learns Cart Bundle Manager script loaded');
// new IrisLearnsCartBundleManager();

/**
 * Iris Learns Cart Bundle Manager
 * Groups Iris Learner + Exo Works Learner as a single bundle in cart
 * Manages add-on quantity sync and display
 * Runs independently from the main IrisCartBundleManager
 */

class IrisLearnsCartBundleManager {
  constructor() {
    console.log('=== Iris Learns Cart Bundle Manager Initialized ===');

    this.productIds = {
      device: 10210718941368,      // Iris Learner
      software: 10217114271928     // Exo Works Learner
    };

    this.addonProductIds = [
      10215211434168,   // Extended Warranty (Device Protection)
      10215210221752    // Exo Works Essential Software
    ];

    this.cart = null;
    this.bundles = [];
    this.isReInitializing = false;
    this.reInitTimeout = null;
    this.init();
  }

  async init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.setup());
    } else {
      this.setup();
    }
  }

  async setup() {
    if (!window.location.pathname.includes('/cart')) return;

    await this.loadCart();
    await this.normalizeQuantities();
    this.analyzeBundles();
    this.renderBundles();
    this.setupCartUpdateListeners();

    console.log('=== Iris Learns Cart Setup Complete ===');
  }

//   setupCartUpdateListeners() {
//     console.log('[IrisLearns] 🎯 Setting up cart update listeners...');
//     this.reInitTimeout = null;

//     const cartItems = document.querySelector('.cart-items tbody') ||
//                       document.querySelector('.cart-items');

//     if (cartItems) {
//       const observer = new MutationObserver(() => {
//         const hasOurBundle = document.querySelector('[id^="IrisLearnsBundle-"]');
//         if (!hasOurBundle) {
//           if (this.reInitTimeout) clearTimeout(this.reInitTimeout);
//           this.reInitTimeout = setTimeout(() => {
//             console.log('[IrisLearns] ⏰ DOM change detected, re-initializing...');
//             this.reInitialize();
//           }, 1200);
//         }
//       });

//       observer.observe(cartItems, {
//         childList: true,
//         subtree: true,
//         attributes: true,
//         attributeFilter: ['style']
//       });
//       console.log('[IrisLearns] ✅ MutationObserver installed');
//     }
//   }

setupCartUpdateListeners() {
    console.log('[IrisLearns] 🎯 Setting up cart update listeners...');
    this.reInitTimeout = null;

    // 1. MutationObserver for DOM changes from the other bundle manager
    const cartItems = document.querySelector('.cart-items tbody') ||
                      document.querySelector('.cart-items');

    if (cartItems) {
      const observer = new MutationObserver(() => {
        const hasOurBundle = document.querySelector('[id^="IrisLearnsBundle-"]');
        if (!hasOurBundle) {
          if (this.reInitTimeout) clearTimeout(this.reInitTimeout);
          this.reInitTimeout = setTimeout(() => {
            console.log('[IrisLearns] ⏰ DOM change detected, re-initializing...');
            this.reInitialize();
          }, 1200);
        }
      });

      observer.observe(cartItems, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['style']
      });
      console.log('[IrisLearns] ✅ MutationObserver installed');
    }

    // 2. Fetch interceptor for native Shopify cart changes (add-on deletions)
    const originalFetch = window.fetch;
    const self = this;

    window.fetch = function(...args) {
      const url = args[0];

      if (typeof url === 'string' && url.includes('/cart/change')) {
        console.log('[IrisLearns] 🌐 Native cart change detected');

        return originalFetch.apply(this, args).then(response => {
          if (self.reInitTimeout) clearTimeout(self.reInitTimeout);
          self.reInitTimeout = setTimeout(() => {
            console.log('[IrisLearns] ⏰ Re-initializing after native cart change');
            self.reInitialize();
          }, 1500);

          return response;
        });
      }

      return originalFetch.apply(this, args);
    };

    console.log('[IrisLearns] ✅ Fetch interceptor installed');
  }

  async reInitialize() {
    if (this.isReInitializing) {
      console.log('[IrisLearns] ⚠️ Re-initialization already in progress, skipping...');
      return;
    }

    this.isReInitializing = true;
    console.log('[IrisLearns] 🔄 === Re-initializing ===');

    // Clear existing Iris Learns bundle cards
    document.querySelectorAll('[id^="IrisLearnsBundle-"]').forEach(el => el.remove());

    // Show any hidden items
    this.cart.items.forEach((item, index) => {
      const cartItemIndex = index + 1;
      const selectors = [
        `#CartItem-${cartItemIndex}`,
        `[data-index="${cartItemIndex}"]`
      ];

      for (const selector of selectors) {
        const element = document.querySelector(selector);
        if (element) {
          const row = element.closest('tr, li, .cart-item');
          if (row) {
            row.style.display = '';
          }
        }
      }
    });

    // Re-run bundle logic
    await this.loadCart();
    await this.normalizeQuantities();
    this.analyzeBundles();
    this.renderBundles();

    console.log('[IrisLearns] ✅ === Re-initialization Complete ===');
    this.isReInitializing = false;
  }

  async loadCart() {
    const response = await fetch('/cart.js');
    this.cart = await response.json();
    console.log('[IrisLearns] Cart loaded:', this.cart.items.length, 'items');
  }

  async normalizeQuantities() {
    const devices = this.cart.items.filter(i => i.product_id === this.productIds.device);
    const softwares = this.cart.items.filter(i => i.product_id === this.productIds.software);

    if (devices.length === 0 || softwares.length === 0) return;

    const updates = {};
    let needsUpdate = false;
    const usedKeys = new Set();

    devices.forEach(device => {
      const deviceProgram = device.properties?.['Program Name'] || '';

      let matchedSoftware = softwares.find(s =>
        !usedKeys.has(s.key) &&
        (s.properties?.['Program Name'] || '') === deviceProgram
      );

      if (!matchedSoftware) {
        matchedSoftware = softwares.find(s => !usedKeys.has(s.key));
      }

      if (matchedSoftware) {
        usedKeys.add(matchedSoftware.key);

        // Find matching add-ons
        const addons = this.cart.items.filter(item =>
          !usedKeys.has(item.key) &&
          this.addonProductIds.includes(item.product_id) &&
          (item.properties?.['Program Name'] || '') === deviceProgram
        );
        addons.forEach(a => usedKeys.add(a.key));

        const allQtys = [device.quantity, matchedSoftware.quantity, ...addons.map(a => a.quantity)];
        const maxQty = Math.max(...allQtys);

        if (device.quantity !== maxQty) { updates[device.key] = maxQty; needsUpdate = true; }
        if (matchedSoftware.quantity !== maxQty) { updates[matchedSoftware.key] = maxQty; needsUpdate = true; }
        addons.forEach(addon => {
          if (addon.quantity !== maxQty) { updates[addon.key] = maxQty; needsUpdate = true; }
        });
      }
    });

    if (needsUpdate) {
      console.log('[IrisLearns] Syncing quantities:', updates);
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates })
      });
      await this.loadCart();
    }
  }

  analyzeBundles() {
    this.bundles = [];
    const usedKeys = new Set();

    const devices = this.cart.items.filter(i => i.product_id === this.productIds.device);
    const softwares = this.cart.items.filter(i => i.product_id === this.productIds.software);

    devices.forEach(device => {
      const deviceProgram = device.properties?.['Program Name'] || '';

      let matchedSoftware = softwares.find(s =>
        !usedKeys.has(s.key) &&
        (s.properties?.['Program Name'] || '') === deviceProgram
      );

      if (!matchedSoftware) {
        matchedSoftware = softwares.find(s => !usedKeys.has(s.key));
      }

      if (matchedSoftware) {
        usedKeys.add(device.key);
        usedKeys.add(matchedSoftware.key);

        // Find add-ons with matching Program Name
        const addons = this.cart.items.filter(item =>
          !usedKeys.has(item.key) &&
          this.addonProductIds.includes(item.product_id) &&
          (item.properties?.['Program Name'] || '') === deviceProgram
        );

        addons.forEach(a => usedKeys.add(a.key));

        this.bundles.push({ device, software: matchedSoftware, addons });
        console.log('[IrisLearns] Bundle found:', device.quantity, 'x Iris Learns, Program:', deviceProgram || '(none)', 'Add-ons:', addons.length);
      }
    });

    console.log(`[IrisLearns] Total bundles: ${this.bundles.length}`);
  }

  renderBundles() {
    if (this.bundles.length === 0) return;

    const cartForm = document.querySelector('form[action="/cart"]');
    if (!cartForm) return;

    const itemsContainer = cartForm.querySelector('.cart-items tbody') ||
                           cartForm.querySelector('.cart-items');
    if (!itemsContainer) return;

    this.bundles.forEach((bundle, index) => {
      this.hideCartItem(bundle.device.key);
      this.hideCartItem(bundle.software.key);

      const bundleCard = this.createBundleCard(bundle, index);
      itemsContainer.insertBefore(bundleCard, itemsContainer.firstChild);

      // Disable quantity buttons on add-ons, keep only delete
      bundle.addons.forEach(addon => {
        this.disableAddonQuantity(addon.key);
      });
    });
  }

  hideCartItem(key) {
    const index = this.cart.items.findIndex(item => item.key === key) + 1;
    const selectors = [
      `#CartItem-${index}`,
      `[data-index="${index}"]`,
      `[data-key="${key}"]`
    ];

    for (const selector of selectors) {
      const element = document.querySelector(selector);
      if (element) {
        const row = element.closest('tr, li, .cart-item');
        if (row) {
          row.style.display = 'none';
          return;
        }
      }
    }
  }

  disableAddonQuantity(key) {
    const index = this.cart.items.findIndex(item => item.key === key) + 1;
    const selectors = [
      `#CartItem-${index}`,
      `[data-index="${index}"]`,
      `[data-key="${key}"]`
    ];

    for (const selector of selectors) {
      const element = document.querySelector(selector);
      if (element) {
        const row = element.closest('tr, li, .cart-item');
        if (row) {
          // Hide the +/- buttons
          row.querySelectorAll('.quantity__button').forEach(btn => {
            btn.style.display = 'none';
          });
          // Make input look like plain text
          const input = row.querySelector('.quantity__input');
          if (input) {
            input.style.border = 'none';
            input.style.pointerEvents = 'none';
            input.readOnly = true;
          }
          // Remove the border on the quantity-input wrapper
          const quantityWrapper = row.querySelector('quantity-input');
          if (quantityWrapper) {
            quantityWrapper.style.border = 'none';
          }
          return;
        }
      }
    }
  }

  createBundleCard(bundle, index) {
    const totalPrice = (
      bundle.device.final_line_price + bundle.software.final_line_price
    ) / 100;

    const row = document.createElement('tr');
    row.className = 'cart-item';
    row.id = `IrisLearnsBundle-${index + 1}`;

    row.innerHTML = `
      <td class="cart-item__media">
        <a href="${bundle.device.url}" class="cart-item__link" aria-hidden="true" tabindex="-1"></a>
        <div class="cart-item__image-container gradient global-media-settings">
          <img
            src="${bundle.device.image}"
            class="cart-item__image"
            alt="${bundle.device.product_title}"
            loading="lazy"
            width="150"
            height="150"
          >
        </div>
      </td>

      <td class="cart-item__details">
        <a href="${bundle.device.url}" class="cart-item__name h4 break">
          Exo Iris - Learner Package
        </a>
        <div class="product-option">
          <p>Includes Exo Iris and 1-year Exo Works Essential Software.</p>
        </div>
      </td>

      <td class="cart-item__totals right medium-hide large-up-hide">
        <div class="cart-item__price-wrapper">
          <span class="price price--end">$${totalPrice.toFixed(2)}</span>
        </div>
      </td>

      <td class="cart-item__quantity">
        <div class="cart-item__quantity-wrapper">
          <quantity-input class="quantity cart-quantity">
            <button class="quantity__button" name="minus" type="button" data-action="decrease" data-learns-bundle="${index}">
              <span class="visually-hidden">Decrease quantity</span>
              <span class="svg-wrapper">
                <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-minus" fill="none" viewBox="0 0 10 2">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 110 1H1A.5.5 0 01.5 1z" fill="currentColor"/>
                </svg>
              </span>
            </button>
            <input
              class="quantity__input"
              type="number"
              value="${bundle.device.quantity}"
              min="1"
              readonly
            >
            <button class="quantity__button" name="plus" type="button" data-action="increase" data-learns-bundle="${index}">
              <span class="visually-hidden">Increase quantity</span>
              <span class="svg-wrapper">
                <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-plus" fill="none" viewBox="0 0 10 10">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z" fill="currentColor"/>
                </svg>
              </span>
            </button>
          </quantity-input>
          <cart-remove-button>
            <button class="button button--tertiary" type="button" data-learns-bundle="${index}">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" aria-hidden="true" focusable="false" class="icon icon-remove">
                <path d="M14 3h-3.53a3.07 3.07 0 00-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 005.53 3H2a.5.5 0 000 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 00.5-.5V4H14a.5.5 0 000-1zM6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02zm4.84 11.52h-7.5V4h7.5v9.5z" fill="currentColor"></path>
                <path d="M6.55 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5zM9.45 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5z" fill="currentColor"></path>
              </svg>
            </button>
          </cart-remove-button>
        </div>
      </td>

      <td class="cart-item__totals right small-hide">
        <div class="cart-item__price-wrapper">
          <span class="price price--end">$${totalPrice.toFixed(2)}</span>
        </div>
      </td>
    `;

    // Quantity buttons
    row.querySelectorAll('button[data-action]').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.handleQuantityChange(e, bundle);
      });
    });

    // Remove button
    row.querySelector('cart-remove-button button').addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      this.handleRemove(bundle);
    });

    return row;
  }

  async handleQuantityChange(e, bundle) {
    const action = e.currentTarget.dataset.action;
    const currentQty = bundle.device.quantity;
    const newQty = action === 'increase' ? currentQty + 1 : Math.max(0, currentQty - 1);

    if (newQty === 0) {
      return this.handleRemove(bundle);
    }

    const updates = {
      [bundle.device.key]: newQty,
      [bundle.software.key]: newQty
    };

    // Sync add-on quantities
    bundle.addons.forEach(addon => {
      updates[addon.key] = newQty;
    });

    await this.updateCart(updates);
  }

  async handleRemove(bundle) {
    const updates = {
      [bundle.device.key]: 0,
      [bundle.software.key]: 0
    };

    // Remove add-ons too
    bundle.addons.forEach(addon => {
      updates[addon.key] = 0;
    });

    await this.updateCart(updates);
  }

  async updateCart(updates) {
    try {
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates })
      });

      if (response.ok) {
        window.location.reload();
      }
    } catch (error) {
      console.error('[IrisLearns] Update failed:', error);
    }
  }
}

console.log('Iris Learns Cart Bundle Manager script loaded');
new IrisLearnsCartBundleManager();